import * as Yup from 'yup'

/**
 * Validação do bloco e-SUS do encerramento.
 *
 * A lotação só é exigida quando o seletor é exibido (mais de uma lotação ativa) — com uma única
 * lotação ela é enviada automaticamente e sem nenhuma lotação o encerramento segue sem o campo,
 * espelhando `aplicarCarimboLotacao` no backend.
 *
 * A conduta é sempre obrigatória: o backend recusa lista vazia com 422.
 */
export const encerramentoEsusSchema = (exigeLotacao: boolean) =>
  Yup.object().shape({
    lotacao: exigeLotacao
      ? Yup.object().nullable().required('Selecione a lotação do atendimento')
      : Yup.object().nullable(),
    condutas: Yup.array().min(1, 'Selecione ao menos uma conduta'),
  })
